export function redirect(url, win = window) {
  win.location.href = url;
}

export function redirectToNewTab(url, win = window) {
  win.open(url);
}
